import { AnyAction } from 'redux';
import { ReduxAction } from '../../enums/const-enums';
import { OverlayState } from '../reducers/overlay-reducer';

export const showOverlay = (overlay: OverlayState): AnyAction => {
  return {
    type: ReduxAction.OVERLAY_UPDATE,
    payload: overlay,
  };
};

export const clearOverlay = (): AnyAction => {
  return {
    type: ReduxAction.OVERLAY_CLEAR,
  };
};
